import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel } from '@angular/material/snack-bar';

import { AbstractSnackBar } from '../abstract-snack-bar/abstract-snack-bar';

type ErrorNotificationItems = Readonly<{

	/** Error message text. */
	message: string;

	/** Optional error title text. */
	title?: string;
}>;

/** Error notification data. */
export type ErrorNotificationData = Readonly<{

	/** Label. */
	label?: string;

	/** Items. */
	items: readonly ErrorNotificationItems[];
}>;

/** Error notification. */
@Component({
	selector: 'protctc-error-notification',
	templateUrl: './error-notification.html',
	styleUrl: './error-notification.css',
	imports: [MatIconButton, MatIcon, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
})
export class ErrorNotification extends AbstractSnackBar<ErrorNotificationData> {}
